import { IJOIST_INPUT_TYPE } from '../../../../../utils/constants'
import { createGenericSlice } from '../../../../../utils/slices'

export const headerSlice = createGenericSlice({
  name: 'header',
  initialState: {
    type: 'solidSawn',
    material: 1,
    width: '2x',
    depth: 6,
    ply: 1,
    topChord: 1,
    isRough: false,
    memberID: 'Header 1',
    ijoistInputType: IJOIST_INPUT_TYPE.MANUFACTURER,
  },
})

export const headerActions = headerSlice.actions
